module.exports = __webpack_public_path__ + "static/media/_united-nations.d2abc9b5.png";